import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { CategoryViewComponentDef } from '@df/catalog-ui/category/view/category-view.component.def';
import { ICategoryDataV3 } from '@df/catalog/category/category';
import { AdvancedCommerceConfigStore } from '@df/module-advanced-commerce';
import { LocalCategory } from '../../model/category/category.decorator';
import { CategoryViewLayoutComponent } from './category-view-layout.component';
import { LocalProduct } from '../../model/product/product.decorator';
import { IProductDataV2 } from '@df/catalog/product/product';
@Component({
    selector: 'category-view',
    template: '<category-view-layout [variant]="lpLayoutVariant" ></category-view-layout>',
    standalone: true,
    imports: [forwardRef(() => CategoryViewLayoutComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryViewComponent extends CategoryViewComponentDef<LocalCategory<ICategoryDataV3>, LocalProduct<IProductDataV2>> {
    protected enabledAc = !!inject(AdvancedCommerceConfigStore)?.config()?.enabled;

    protected override resetListing(): void {
        // Disable listing if AC is enabled to avoid klevu tracking
        if (!this.enabledAc) {
            super.resetListing();
        }
    }

    get lpLayoutVariant(): string | undefined {
        return this.model?.lpLayoutVariant;
    }
}
